<div class="country-selector-wrapper">
  <button class="d-flex align-items-center btn btn-link footer-link" (click)="openDrawer()">
    <i nz-icon nzType="global" nzTheme="outline"></i>
    <span>{{ 'common.countrySelector_action' | cxTranslate }}</span>
  </button>
</div>

<ng-template #countrySelectorDrawerTemplate>
  <py-drawer-template [title]="'common.countrySelector_title' | cxTranslate" [body]="drawerBody"> </py-drawer-template>

  <ng-template #drawerBody>
    <div class="mt-3" *ngIf="{ node: node$ | async, activeCountry: activeCountry$ | async } as observables">
      <ng-container *ngFor="let links of observables.node?.children">
        <a
          *ngFor="let site of links.children | orderBy : 'title' : 'string' : false"
          [ngClass]="{ inactive: isSelected(site, observables.activeCountry) }"
        >
          <div
            class="country-item py-2"
            [ngClass]="{ selected: isSelected(site, observables.activeCountry) }"
            (click)="handleClick(site, observables.activeCountry)"
          >
            <i class="mr-1 flag-sprite" [ngClass]="site?.countryFlagSprite"></i>

            <span>{{ site?.title }}</span>

            <div class="d-flex flex-grow-1 justify-content-end" *ngIf="isSelected(site, observables.activeCountry)">
              <i class="check-icon" nz-icon nzType="check-circle" nzTheme="fill"></i>
            </div>
          </div>
        </a>
      </ng-container>
    </div>
  </ng-template>
</ng-template>
